/**
 * Format a date as a "time ago" string
 * @param date The date to format
 * @returns Formatted string like "2 days ago" or "just now"
 */
export const formatTimeAgo = (date: Date): string => {
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
  
  if (diffInSeconds < 60) {
    return 'just now';
  }
  
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
  }
  
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
  }
  
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 7) {
    return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
  }
  
  // For older dates, just use the formatted date
  return date.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric' 
  });
};

/**
 * Format a number with commas as thousand separators
 * @param num The number to format
 * @returns Formatted string with commas
 */
export const formatNumber = (num: number): string => {
  return num.toLocaleString();
};

/**
 * Format currency amount
 * @param amount The amount to format
 * @param currency The currency code (default: USD)
 * @returns Formatted string like "$1,234.56"
 */
export const formatCurrency = (amount: number, currency: string = 'USD'): string => {
  return `$${formatNumber(amount)}`;
}; 